import { render, staticRenderFns } from "./LogoBar.vue?vue&type=template&id=199b9ba2&scoped=true"
import script from "./LogoBar.vue?vue&type=script&lang=js"
export * from "./LogoBar.vue?vue&type=script&lang=js"
import style0 from "./LogoBar.vue?vue&type=style&index=0&id=199b9ba2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b9ba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199b9ba2')) {
      api.createRecord('199b9ba2', component.options)
    } else {
      api.reload('199b9ba2', component.options)
    }
    module.hot.accept("./LogoBar.vue?vue&type=template&id=199b9ba2&scoped=true", function () {
      api.rerender('199b9ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/type_4/LogoBar.vue"
export default component.exports